export interface IStatus {
  created_at: string | Date;
  id: number;
  name: string;
  updated_at: string | Date;
}

export enum Status {
  NOT_PAID = 2,
  ACCEPTED,
  PART_DELIVERED,
  ISSUED,
  ORDERED
}